let isEnabled = false;

export function getIsWorkerAppRebrandingEnabled(): boolean {
  return isEnabled;
}

export function setWorkerAppRebrandingEnabled(value: boolean): void {
  isEnabled = value;
}
